require('./movementsTable.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ helpers
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @ components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// @ commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
// @ helpers
const { LabelDate } = require('commonsComponents/labelDate');
// @ constants
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');

class MovementsTable extends React.Component {

    buildColumnsTable() {
        let response;

        response = (
            <thead>
                <OKTableRow asHeader={true}>
                    <OKTableCell asHeader={true} className="movements-table__date">
                        <FormattedText value="movements-date" />
                    </OKTableCell>
                    <OKTableCell asHeader={true} className="movements-table__date-value">
                        <FormattedText value="movements-dateValue" />
                    </OKTableCell>
                    <OKTableCell asHeader={true} className="movements-table__description">
                        <FormattedText value="movements-description" />
                    </OKTableCell>
                    <OKTableCell asHeader={true} className="movements-table__amount">
                        <FormattedText value="movements-amount" />
                    </OKTableCell>
                </OKTableRow>
            </thead>
        );

        return response;
    }

    buildContentTable() {
        let response;

        response = this.props.immMovementsList.map((immMovement, id) => {
            const date = immMovement.get('ftext');
            const valueDate = immMovement.get('fecmov');
            const description = immMovement.get('cflargo');
            const amount = immMovement.get('impliquid');
            const plainAmountObject = getPlainAmountObject({ amount: amount.replace('.', ''), currency: 'EUR' });
            const language = getLanguage();

            return (
                <OKTableRow key={id}>
                    <OKTableCell className="movements-row__date">
                        <LabelDate
                            date={date}
                            language={language}
                            today={LABEL_DATE_TODAY}
                            yesterday={LABEL_DATE_YESTERDAY}
                        />
                    </OKTableCell>
                    <OKTableCell className="movements-row__date-value">
                        <LabelDate
                            date={valueDate}
                            language={language}
                            today={LABEL_DATE_TODAY}
                            yesterday={LABEL_DATE_YESTERDAY}
                        />
                    </OKTableCell>
                    <OKTableCell className="movements-row__description--black">
                        {description}
                    </OKTableCell>
                    <OKTableCell className="movements-row__amount--black">
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                    </OKTableCell>
                </OKTableRow>
            );
        });

        return (
            <tbody>
                {response}
            </tbody>
        );
    }

    render() {
        const columnsTable = this.buildColumnsTable();
        const contentTable = this.buildContentTable();

        return (
            <section className="movements-table">
                <OKTable>
                    {columnsTable}
                    {contentTable}
                </OKTable>
            </section>
        );
    }
}

MovementsTable.propTypes = {
    immMovementsList: PropTypes.object.isRequired
};

module.exports = MovementsTable;
